import React from 'react';
import PropTypes from 'prop-types';
import { ListGroup, Form } from 'react-bootstrap';
import { isEmpty, map } from 'lodash';

import { isMaps } from '../../../modules/checkDeployEnv';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';

import ToggleSwitch from '../ToggleSwitch';
import BlankState from '../BlankState';
import MapsProfileSettings from '../MapsProfileSettings';
import Styles from './styles';

const SettingValue = ({ type, keyName, value, onChange }) => {
  let componentToRender = '';
  switch (type) {
    case 'boolean':
      componentToRender = (
        <ToggleSwitch
          id={keyName}
          toggled={value}
          onToggle={(id, toggled) => onChange({ key: keyName, value: toggled })}
        />
      );
      break;
    case 'number':
      componentToRender = (
        <Form.Control
          type="number"
          value={value}
          onChange={event => onChange({ key: keyName, value: parseInt(event.target.value, 10) })}
        />
      );
      break;
    case 'string':
      componentToRender = (
        <Form.Control
          type="text"
          value={value}
          onChange={event => onChange({ key: keyName, value: event.target.value })}
        />
      );
      break;

    default:
      break;
  }

  return componentToRender;
};

SettingValue.propTypes = {
  type: PropTypes.string.isRequired,
  keyName: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
  onChange: PropTypes.func.isRequired
};

class UserSettings extends React.Component {
  state = { loading: true, settings: [] };

  componentDidMount() {
    this.fetchSettings();
  }

  componentWillUnmount() {
    // TODO: cancel fetch in promise
  }

  handleUpdateSetting = async setting => {
    const { userId } = this.props;
    try {
      await methodPromise('users.updateSetting', { userId, ...setting });
      this.fetchSettings();
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  fetchSettings = async () => {
    try {
      const settings = await methodPromise('users.fetchSettings', this.props);
      this.setState({ settings, loading: false });
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  render() {
    const { loading, settings } = this.state;
    const { isAdmin, layerList, profile, deployEnv, userControlSetting } = this.props;

    if (loading) {
      return <div className="UserSettings" />;
    }
    if (isEmpty(settings) && (isEmpty(profile) || !isMaps(deployEnv))) {
      return (
        <ListGroup>
          <BlankState
            icon={{ style: 'solid', symbol: 'cogs' }}
            title={`No settings to manage ${isAdmin ? 'for this user' : 'yet'}.`}
            subtitle={`${
              isAdmin ? 'GDPR-specific settings intentionally excluded. ' : ''
            } When there are settings to manage, they'll appear here.`}
          />
        </ListGroup>
      );
    }
    return (
      <ListGroup>
        {map(settings, ({ _id, key, label, type, value }) => (
          <Styles.Setting key={key} className="clearfix">
            <p>{label}</p>
            <div>
              <SettingValue
                type={type}
                keyName={key}
                value={value}
                onChange={update => this.handleUpdateSetting({ ...update, _id })}
              />
            </div>
          </Styles.Setting>
        ))}
        <MapsProfileSettings
          deployEnv={deployEnv}
          layerList={layerList}
          profile={profile}
          userControlSetting={userControlSetting}
        />
      </ListGroup>
    );
  }
}

UserSettings.defaultProps = {
  deployEnv: '',
  isAdmin: false,
  layerList: [],
  profile: {},
  userControlSetting: {},
  userId: null
};

UserSettings.propTypes = {
  deployEnv: PropTypes.string,
  isAdmin: PropTypes.bool,
  layerList: PropTypes.array,
  profile: PropTypes.object,
  userControlSetting: PropTypes.object,
  userId: PropTypes.string
};

export default UserSettings;
